module.exports = __webpack_public_path__ + "img/vision-icon.ae31a667.svg";